export default "__VITE_ASSET__224605e9__"